import { DBDef_AdvisorSnippet } from '@app/advisor-content-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_AdvisorSnippet } from '../../_entity/snippet/ModuleFE_AdvisorSnippet.js';
import { ModuleFE_AdvisorWizard } from '../../_entity/wizard/ModuleFE_AdvisorWizard.js';
import { Manager_AdvisorSnippet } from '../../ui/_managers/Manager_AdvisorSnippet/Manager_AdvisorSnippet.js';
import { ModuleFE_Tag, ModuleFE_Variable } from '@app/hcs-frontend';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_AdvisorSnippet,
    dbDef: DBDef_AdvisorSnippet,
    tag: ['As', 'Advisor Snippet'],
    modulesToAwait: [ModuleFE_AdvisorSnippet, ModuleFE_AdvisorWizard, ModuleFE_Variable, ModuleFE_Tag],
    ManagerComponent: Manager_AdvisorSnippet,
});
export const WorkHubItem_AdvisorSnippet = WorkHubItem;
export const UtilObject_AdvisorSnippet = UtilObject;
export const SearchItem_AdvisorSnippet = SearchItem;
//# sourceMappingURL=advisor-snippet.js.map